<template>
  <ItinerarySummaryCard type="hotel" :price="totalPrice">
    <div class="flex flex-col gap-10">
      <ItinerarySummaryHotelCardContent
        v-for="hotel in items"
        :key="hotel.uniqueId"
        :hotel="hotel"
      />
    </div>
  </ItinerarySummaryCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ItinerarySummaryCard from '../ItinerarySummaryCard/ItinerarySummaryCard.vue'
import ItinerarySummaryHotelCardContent from './ItinerarySummaryHotelCardContent/ItinerarySummaryHotelCardContent.vue'
import type { Props } from './ItinerarySummaryHotelCard.types'
import { useCurrency } from '@/modules/Core/composables'

const props = defineProps<Props>()

const { formatCurrency } = useCurrency()

const totalPrice = computed(() => {
  const prices = props.items
    .map((item) => item.rooms.map((room) => room.price))
    .flat()
  const total = prices.reduce((acc, price) => acc + price, 0) + 0

  return formatCurrency(
    Number(total.toFixed(2)),
    props.items[0].convertedCurrency
  ).value
})
</script>
